import React from 'react';
import BraftEditor, {EditorState} from 'braft-editor';
import 'braft-editor/dist/index.css';
import {useAxios} from '../Http/AxiosProvider';

export default function ExBraftEditor(props: {value: EditorState; onChange: (v: EditorState) => any}) {
  const axios = useAxios();
  return (
    <div className={'ExBraftEditor'}>
      <BraftEditor
        value={props.value}
        onChange={props.onChange}
        media={{
          uploadFn(params) {
            const fd = new FormData();
            fd.append('file', params.file);
            axios.instance
              .post<{url: string; path: string}>('Article/UploadImage', fd, {
                onUploadProgress(event) {
                  params.progress((event.loaded / event.total) * 100);
                },
              })
              .then(res => {
                if (res.data) {
                  params.success({
                    url: res.data.url,
                    meta: {
                      id: res.data.path,
                      title: params.file.name,
                      alt: params.file.name,
                      loop: false,
                      autoPlay: false,
                      controls: false,
                      poster: '',
                    },
                  });
                }
              })
              .catch(e => {
                params.error(e.message);
              });
          },
        }}
      />
    </div>
  );
}
